import { Specimen } from "pwapi";

import { CaseDetailState } from "shared/reducers/caseDetailReducer";

import "./AutoCPTCodes.css";
import { cptCodeStringFromChargeCaches } from "components/caseReport/utils";

export const cptChargesForSpecimen = (
  caseDetail: CaseDetailState,
  specimen: Specimen
) => {
  const block_ids = caseDetail.blocks
    ?.filter((b) => b.specimen_id === specimen.id)
    ?.map((b) => b.id);
  const lab_order_ids = caseDetail.lab_orders
    ?.filter((l) => block_ids?.includes(l.block_id))
    ?.map((l) => l.id);
  const cpt_charges = caseDetail.charge_caches
    ?.filter((c) => c.type === "cpt_code" && c.row_object?.model === "laborder")
    .filter((c) => lab_order_ids?.includes(c.row_object?.object_pk));
  return cpt_charges;
};

const AutoCPTCodes = ({
  caseDetail,
  specimen,
  preview,
}: {
  caseDetail: CaseDetailState;
  specimen: Specimen;
  preview?: boolean;
}) => {
  const cptCharges = cptChargesForSpecimen(caseDetail, specimen);
  return (
    <div className="AutoCPTCodes">
      <label>{preview ? "Suggested CPT Codes:" : "CPT"}</label>
      {cptCharges && (
        <div>
          {cptCodeStringFromChargeCaches(
            preview
              ? cptCharges.filter((c) => !c.cpt_code?.code?.endsWith("T"))
              : cptCharges
          )}
        </div>
      )}
    </div>
  );
};

export default AutoCPTCodes;
